/**
 * iOS (SKStoreReviewController) and Android (Play In-App Review) rating sheet through
 * `@capawesome/capacitor-app-review` (v8), loaded from the native entry chunk
 * (NativeLoaders.review). Only requestReview() is used: openAppStore() would leave the game.
 *
 * Both stores decide whether the sheet shows and say nothing back, so this resolves when the
 * request was handed over. A build without the plugin rejects with Capacitor's UNIMPLEMENTED;
 * the caller (a prompt the player never asked for) reports it and carries on.
 */
import type { Loader } from '../lazy.js';
import type { ReviewProvider } from './types.js';

/** The part of @capawesome/capacitor-app-review used here. */
export interface AppReviewModule {
  AppReview: { requestReview(): Promise<void> };
}

export class NativeReviewProvider implements ReviewProvider {
  readonly kind = 'native';
  readonly available = true;

  constructor(private readonly load: Loader<AppReviewModule>) {}

  async request(): Promise<void> {
    const { AppReview } = await this.load();
    await AppReview.requestReview();
  }
}
